// @flow

import admin from "./admin"
import bc from "./bc"

const externalApps = {
  admin: (admin: {
    id: string,
    intlBase: string,
    localUrl: string,
    url: any,
    ...
  }),
  bc: (bc: {
    id: string,
    intlBase: string,
    localUrl: string,
    url: string,
    ...
  })
}

export default externalApps
